import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninModalClosed = (
  track: RedcatAnalyticsStore['track'],
  {
    fieldsCompletedCount,
    lastFieldFocused,
  }: { fieldsCompletedCount: number; lastFieldFocused: string | null },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.ModalClosed,
    properties: {
      fields_completed_count: fieldsCompletedCount,
      last_field_focused: lastFieldFocused,
    },
  };

  track(event);
};
